import React, { useState } from "react";
import CustomForm from "../Form/CustomForm";
import InputField from "../Form/InputField";
import { useFormik } from "formik";
import axios from "axios";
import Checkbox from "../Form/Checkbox";
import * as Yup from "yup";
import { BASE_URL } from "../../config.json";

const validationSchema = Yup.object().shape({
  full_name: Yup.string()
    .min(3, "Too Short!")
    .max(50, "Too Long!")
    .required("Required*"),
  email: Yup.string().email("Invalid email address").required("Required*"),
  phone_number: Yup.string().required("Required*"),
  your_message: Yup.string().min(8, "Too Short!").required("Required*"),
  subscribe: Yup.boolean().oneOf([true], "Required*"),
});

const initialValues = {
  full_name: "",
  email: "",
  phone_number: "",
  your_message: "",
  subscribe: false,
};

export const clearAllSpace = (str) => str.replace(/[^0-9\s]/g, "");
const ContactForm = ({ setthanku, toast, centerClass }) => {
 
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      const data = {
        full_name: values.full_name,
        email: values.email,
        phone: values.phone_number,
        message: values.your_message,
        subscribe: values.subscribe,
      };
        sendData(data, resetForm);
     
    },
    enableReinitialize: true,
  });

  //   ======================== || FUNCTION TO HANDLE SEND CONTACT FORM ||============================
  const sendData = (data, resetForm) => {
    axios      
      .post(`${BASE_URL}/contactus/`, data)
      .then((res) => {
        toast.success("Details Sent successfully");
        setthanku(true);
        resetForm();       
      })
      .catch((err) => {
        console.log(err)
        toast.error("Something is wrong!");
        resetForm();
      });
  };

  return (
    <CustomForm
      className="contact__form"
      formik={formik}
      initialValues={initialValues}
    >
      <div className="two">
        <InputField
          name="full_name"
          placeholder={"FULL NAME*"}
          onChange={formik.handleChange}
          value={formik.values.full_name}
          error={formik.errors.full_name}
          touched={formik.touched.full_name}
        />
        <InputField
          name="email"
          placeholder={"EMAIL ADDRESS*"}
          onChange={formik.handleChange}
          value={formik.values.email}
          error={formik.errors.email}
          touched={formik.touched.email}
        />
      </div>

      <div className="one">
        <InputField
          type="number"
          name="phone_number"
          placeholder={"PHONE NUMBER*"}
          value={formik.values.phone_number}
          onChange={(event) =>
            formik.setFieldValue(
              "phone_number",
              clearAllSpace(event.target.value)
            )
          }
          error={formik.errors.phone_number}
          touched={formik.touched.phone_number}
        />
      </div>

      <div className="one">
        <textarea
          className="form__input"
          type="textarea"
          name="your_message"
          placeholder={"YOUR MESSAGE*"}
          onChange={formik.handleChange}
          value={formik.values.your_message}
          rows="4"
          cols="50"
        />

        <div className="error">
          { formik.touched.your_message &&  formik.errors.your_message && (
            <div>{formik.errors.your_message}</div>
          )}
        </div>
      </div>

      <div className={`one ${centerClass}`}>
        <Checkbox
          name={"subscribe"}
          onChange={formik.handleChange}
          value={formik.values.subscribe}
          newClass={centerClass}
        />
        <div className="error">
          { formik.touched.subscribe && formik.errors.subscribe && <div>{formik.errors.subscribe}</div>}
        </div>
      </div>
      <div className={`one ${centerClass}`}>
        <button type="submit" className="btn-color">
          SEND
        </button>
      </div>
    </CustomForm>
  );
};

export default ContactForm;
